export const types = {
    LOGIN_LOADING: 'LOGIN_LOADING',
    SET_USER: 'SET_USER'
}

/**
 * 公共dispatch
 * 
 * @export
 * @param {any} type action type
 * @param {any} payload new state
 * @returns 
 */
export function loginLoading(payload) {
    return function (callback) {
        callback({type: types.LOGIN_LOADING, payload})
    }
}

export function setUser(payload) {
    return function(callback) {
        callback({type: types.SET_USER, payload})
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/index.js